<app-modal-box [maxWidth]="483">
  <ng-container modal-header>
    <div class="box box-highlight">Rain</div>
    <div class="title force-center">
      <span class="highlight">Tip into Rain</span>
    </div>
  </ng-container>
  <div class="content">
    <div class="info">
      Add money to public rain pool, it will be added on top<br />
      of everyone's rakeback rewards
    </div>
    <div class="input-container">
      <div class="label">AMOUNT</div>
      <div class="input-group">
        <input type="number" placeholder="Amount..." [(ngModel)]="tipAmount" [disabled]="submitting()" />
      </div>
    </div>
    <button class="btn btn-yellow tip" [disabled]="submitting()" (click)="tipRain()">Tip User</button>
  </div>
</app-modal-box>
